export default __webpack_public_path__ + "static/media/venture-light.f8b1eb08.svg";